var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "reference-layout",
    {
      staticClass: "functions",
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c("reference-header", {
                attrs: { "header-title": "Функции" },
                scopedSlots: _vm._u([
                  {
                    key: "header-actions",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "layout-header-action" },
                          [
                            _c("c-button-1", {
                              staticClass: "functions__add-new",
                              attrs: {
                                label: "Новая функция",
                                icon: {
                                  icon: "plus",
                                  color: "blue",
                                },
                                color: "white",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$router.push({
                                    name: "function-information",
                                  })
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "subheader",
          fn: function () {
            return [
              _c("div", { staticClass: "functions__filters" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col col-xl-5 col-md-6 col-12" },
                    [
                      _c("c-select", {
                        attrs: {
                          type: "select",
                          label: "Должность",
                          multiple: true,
                          searchable: true,
                          placeholder: "Все",
                          items: _vm.collections.post,
                          checkbox: true,
                          "checkbox-value": _vm.filtersForm.postReverse,
                          "checkbox-type": "icon",
                          "checkbox-tooltip": {
                            disabledText:
                              "Фильтр по всем значениям в справочнике, кроме выбранных",
                            activeText:
                              "Выключить фильтр по всем значениям в справочнике, кроме выбранных",
                            notActiveText:
                              "Включить фильтр по всем значениям в справочнике, кроме выбранных",
                          },
                          useCustomColors: true,
                        },
                        on: {
                          checkboxChange: function ($event) {
                            _vm.filtersForm.postReverse = $event
                          },
                        },
                        model: {
                          value: _vm.filtersForm.post,
                          callback: function ($$v) {
                            _vm.$set(_vm.filtersForm, "post", $$v)
                          },
                          expression: "filtersForm.post",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col col-xl-4 col-md-6 col-12" },
                    [
                      _c("c-select", {
                        attrs: {
                          type: "select",
                          label: "Филиал",
                          multiple: true,
                          searchable: true,
                          placeholder: "Все",
                          items: _vm.collections.filials,
                          checkbox: true,
                          "checkbox-value": _vm.filtersForm.filialReverse,
                          "checkbox-type": "icon",
                          "checkbox-tooltip": {
                            disabledText:
                              "Фильтр по всем значениям в справочнике, кроме выбранных",
                            activeText:
                              "Выключить фильтр по всем значениям в справочнике, кроме выбранных",
                            notActiveText:
                              "Включить фильтр по всем значениям в справочнике, кроме выбранных",
                          },
                          useCustomColors: true,
                        },
                        on: {
                          checkboxChange: function ($event) {
                            _vm.filtersForm.filialReverse = $event
                          },
                        },
                        model: {
                          value: _vm.filtersForm.filial,
                          callback: function ($$v) {
                            _vm.$set(_vm.filtersForm, "filial", $$v)
                          },
                          expression: "filtersForm.filial",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col col-xl-3 col-md-6 col-12" },
                    [
                      _c("c-select", {
                        attrs: {
                          type: "select",
                          label: "Статус",
                          multiple: true,
                          searchable: true,
                          placeholder: "Все",
                          items: _vm.collections.status,
                          checkbox: true,
                          "checkbox-value": _vm.filtersForm.statusReverse,
                          "checkbox-type": "icon",
                          "checkbox-tooltip": {
                            disabledText:
                              "Фильтр по всем значениям в справочнике, кроме выбранных",
                            activeText:
                              "Выключить фильтр по всем значениям в справочнике, кроме выбранных",
                            notActiveText:
                              "Включить фильтр по всем значениям в справочнике, кроме выбранных",
                          },
                          useCustomColors: true,
                        },
                        on: {
                          checkboxChange: function ($event) {
                            _vm.filtersForm.statusReverse = $event
                          },
                        },
                        model: {
                          value: _vm.filtersForm.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.filtersForm, "status", $$v)
                          },
                          expression: "filtersForm.status",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col col-xl-5 col-md-6 col-12" },
                    [
                      _c("c-input", {
                        attrs: {
                          type: "text",
                          label: "Наименование",
                          placeholder: "Любое",
                          clearable: true,
                        },
                        model: {
                          value: _vm.filtersForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.filtersForm, "name", $$v)
                          },
                          expression: "filtersForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "col col-12 col-md-12 col-xl-7" }, [
                    _c(
                      "div",
                      { staticClass: "functions__filters-actions" },
                      [
                        _c("c-button", {
                          staticClass: "functions__filters-action",
                          attrs: { label: "Сбросить", size: "large" },
                          on: { click: _vm.resetFilters },
                        }),
                        _c("c-button", {
                          staticClass: "functions__filters-action",
                          attrs: { label: "Применить", color: "primary" },
                          on: { click: _vm.applyFilters },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "functions__table-actions" },
                [
                  _c("c-button-1", {
                    staticClass: "functions__table-action",
                    attrs: {
                      responsive: "",
                      disabled:
                        _vm.isLoadingData ||
                        _vm.tableData.activeFilteredColumns.length === 0,
                      label: "Сбросить фильтры столбцов",
                      icon: { color: "pink", icon: "filter-drop" },
                      type: "with-icon",
                    },
                    on: { click: _vm.resetColumnFilters },
                  }),
                  _c("c-button-1", {
                    staticClass: "functions__table-action",
                    attrs: {
                      responsive: "",
                      label: "Настроить столбцы",
                      icon: "cog",
                      type: "with-icon",
                    },
                    on: { click: _vm.openColumnSettingsModal },
                  }),
                  _c("m-table-settings", {
                    ref: "columnSettings",
                    attrs: {
                      columns: _vm.tableData.defaultColumns,
                      "disabled-columns": _vm.tableData.disabledColumns,
                      "default-disabled-columns":
                        _vm.tableData.defaultDisabledColumns,
                    },
                    on: { apply: _vm.submitTableSettings },
                  }),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "list",
          fn: function () {
            return [
              !_vm.isLoadingData || _vm.tableData.page > 1
                ? _c("c-data-table", {
                    ref: "accountHistory",
                    staticClass: "functions__table",
                    attrs: {
                      levels: 1,
                      "sorted-column": _vm.tableData.sortedColumn,
                      "disabled-columns": _vm.tableData.disabledColumns,
                      "filtered-columns": _vm.tableData.filteredColumns,
                      "active-filtered-columns":
                        _vm.tableData.activeFilteredColumns,
                      data: _vm.tableData,
                      "reference-list": _vm.tableData.referenceFilterList,
                      "empty-records-label": "Записи не найдены",
                      "operations-status": "active",
                    },
                    on: {
                      sortedEvent: _vm.onTableSort,
                      getReferenceValues: _vm.setColumnReferenceFilterList,
                      "reset-column-filters": function ($event) {
                        _vm.tableData.activeFilteredColumns = []
                      },
                      "remove-column-filter": _vm.onColumnFilterRemove,
                      "set-column-filter": _vm.onSetColumnFilter,
                      "set-column-filter-by-index":
                        _vm.onSetColumnFilterByIndex,
                      "disable-column-sorted-flag":
                        _vm.onDisableColumnSortedFlag,
                      "change-sorting-column": _vm.onSortingColumnChange,
                      remove: _vm.removeCalculationSheet,
                      editRecord: _vm.editRecord,
                    },
                  })
                : _vm._e(),
              _vm.isLoadingData
                ? _c("c-loader", {
                    attrs: {
                      label: "Данные загружаются",
                      active: _vm.isLoadingData,
                      height: "200",
                    },
                  })
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          !_vm.isLoadingData
            ? _c("display-shown-items-count", {
                attrs: {
                  "total-items-count": _vm.totalItemsCount,
                  "shown-items-count": _vm.tableData.records.length,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }